import './ApexCodeHighlight.scss';
import { AiExplainButton } from './AiExplainButton';
import classNames from 'classnames';
import { CodeItem } from '@ui/general/CodeItem';
import React from 'react';
import { useBoolean } from '@hooks';
import { LinkKind, SonarObjectType } from '@sonar-software/sonar-ts-types';
const placeholder = '...';
const getSonarObjectType = (syntaxKind) => {
    switch (syntaxKind) {
        case LinkKind.SfdcApexClass:
            return SonarObjectType.SalesforceApexClass;
        case LinkKind.SfdcEntity:
            return SonarObjectType.SalesforceEntity;
        case LinkKind.SfdcField:
            return SonarObjectType.SalesforceField;
        default:
            return '';
    }
};
export const ApexCodeHighlight = ({ apexSonarObjectId, spans, index }) => {
    const [showExplain, setShowExplain] = useBoolean(false);
    if (!spans) {
        return React.createElement("div", null, placeholder);
    }
    return (React.createElement("div", { className: 'apex-code', onMouseEnter: setShowExplain.on, onMouseLeave: setShowExplain.off },
        apexSonarObjectId && React.createElement(AiExplainButton, { hidden: !showExplain, sonarObjectId: apexSonarObjectId }),
        React.createElement("div", { className: 'apex-code-inner' }, spans.map(([text, linkType, sonarObjectId, syntaxKind], i) => {
            const type = getSonarObjectType(linkType);
            const periscopeOptions = type ? {
                id: sonarObjectId,
                name: '',
                openedFromIndex: index,
                type
            } : undefined;
            const className = classNames(`highlight-${syntaxKind || linkType}`);
            const key = `${i}-${text}`;
            return (React.createElement(CodeItem, { className: className, code: text, key: key, sections: {
                    periscopeOptions
                } }));
        }))));
};
